import React, { useState, useEffect, useRef } from 'react';
import './CostBreakRange.css';

const CostBreakRange = ({ initialValue = 80, onChange }) => {
  const [value, setValue] = useState(initialValue);
  const [inputValue, setInputValue] = useState(String(initialValue));
  const sliderRef = useRef(null);
  const tooltipRef = useRef(null);
  const numberInputRef = useRef(null); // <-- this was missing

  const min = 0;
  const max = 1000;

  const updateSliderUI = () => {
    if (!sliderRef.current || !tooltipRef.current) return;

    const percent = ((value - min) / (max - min)) * 100;

    tooltipRef.current.style.left = `calc(${percent}% + (${8 - percent * 0.15}px))`;
    tooltipRef.current.style.transform = 'translateX(-50%)';

    sliderRef.current.style.background = `
      linear-gradient(90deg, #33F7BE 0%, #4597F8 24%, #BF5AF2 65%) 0% / ${percent}% 100% no-repeat,
      #ddd`;
  };

  useEffect(() => {
    updateSliderUI();
    setInputValue(String(value));
  }, [value]);

  const handleValueChange = (newValue) => {
    const clampedValue = Math.min(Math.max(newValue, min), max); // Clamp value
    setValue(clampedValue);
    if (onChange) onChange(clampedValue);
  };

  const handleSliderChange = (e) => {
    handleValueChange(Number(e.target.value));
  };

  const handleInputChange = (e) => {
    const val = e.target.value;
    setInputValue(val);
    if (/^\d+$/.test(val)) {
      handleValueChange(Number(val));
    }
  };

  const handleInputBlur = (e) => {
    let val = e.target.value;
    if (val === '' || isNaN(Number(val))) {
      setInputValue(String(value));
      return;
    }
    let num = Number(val);
    if (num > max) num = max;
    if (num < min) num = min;
    handleValueChange(num);
  };

  const handleMinus = () => {
    handleValueChange(value - 1);
  };

  const handlePlus = () => {
    handleValueChange(value + 1);
  };

  return (
    <div className='rangeSliderCostOuter'>
        <h3>Our most popular plan includes preferred pricing <br/>for your <small>fleet size of </small> 
          <div className="inputVehicleCost">
            <input
            ref={numberInputRef}
            type="number"
            className="form-control"
            min={min}
            max={max}
            value={inputValue}
            onChange={handleInputChange}
            onBlur={handleInputBlur}
            />
            <span className="value-text">vehicles</span>
          </div>
          {/* <span className="value-text"><span>{value}</span> vehicles</span> */}
        </h3>

        <div className='rangeSliderCostInner'>
          <div className="slider-container">
            <div className="tooltipCustom"
              ref={tooltipRef}
              style={{
                position: 'absolute',
                top: '-50px',
                backgroundColor: '#1f0077',
                color: '#33F7BE',
                padding: '5px 10px',
                borderRadius: '20px',
                fontSize: '15px',
                fontWeight: '600', 
                transition: 'left 0.1s ease',
              }}
            >
              {value}
            </div>
            <input
              ref={sliderRef}
              type="range"
              min={min}
              max={max}
              value={value}
              onChange={handleSliderChange}
            />
            <div className="buttons">
              <button className="buttonsRangeMinus" onClick={handleMinus}>−</button>
              <button className="buttonsRangePlus" onClick={handlePlus}>+</button>
            </div>
          </div>
        </div>
    </div>  
  );
};

export default CostBreakRange;
